module.exports = __webpack_public_path__ + "static/media/rzesy-ikona.50ea9058.png";